import { useEffect, useState } from "react";
import { Box, Button, Card, Flex, Text } from "rebass/styled-components";
import Modal from "styled-react-modal";
import Select, { ActionMeta, components } from "react-select";
import { IThumbnailAipRecipeOutput } from "../../../../graphql/types/queries/recipes";
import Recipes from "./Recipes";
import ViewRecipe from "./ViewRecipe";
import { RbCircledChecked, RbCircledUnchecked } from "../../../../components/RadioButton";
import { ReactSelectStyles } from "../../../../styles/ReactSelectStyles";
import Articles from "./Articles";
import { IArticle } from "../../../../graphql/types/queries/articles";
import ViewArticle from "./ViewArticle";
import SpeakerSeries from "./SpeakerSeries";
import { ISpeakerSerie } from "../../../../graphql/types/queries/speakerSeries";
import { IThyroidGuide } from "../../../../graphql/types/queries/thyroidGuides";
import ThyroidGuides from "./ThyroidGuides";
import styled from "styled-components";
import { useQuery } from "@apollo/client";
import { GET_HS_SAVED_REPLIES, GET_HS_SAVED_REPLY, GET_PATIENT_BY_ID } from "../../../../graphql/queries";
import { IGetHSSavedRepliesOutput, IGetHSSavedRepliesInput, IGetHSSavedReplyInput, IGetHSSavedReplyOutput } from "../../../../graphql/types/queries/conversation";
import AddResourceModal from "./AddResource";
import { IGetProviderPatientByIdInput, IGetProviderPatientByIdOutput } from "../../../../graphql/types/queries/patient";
import { Input } from "../../../../components/TextInput";
import withSession from "../../../../lib/withSession";
import { IUser } from "../../../../graphql/types/queries/user";

const Wrap = styled(Flex)`
  border-radius: 20px;

  @media screen and (max-width: 68.8125em) {
    border-radius: 0;
  }
`

interface ILinksToAdd {
}
enum EOptionsResourcesValues {
  'Recipes',
  'Articles',
  'SpeakerSeries',
  'ThyroidGuides',
}
interface IOptionsResources {
  value: EOptionsResourcesValues
  label: string;
}
const optionsResources: Array<IOptionsResources> = [
  { value: EOptionsResourcesValues.ThyroidGuides, label: 'Thyroid Guides' },
  { value: EOptionsResourcesValues.Recipes, label: 'Recipes' },
  { value: EOptionsResourcesValues.Articles, label: 'Articles' },
  { value: EOptionsResourcesValues.SpeakerSeries, label: 'Speaker Series' },
]

const Option = (props: any) => {
  return (
    <components.Option {...props}>
      <Flex alignItems={'center'}>
        {props.isSelected ? (
          <RbCircledChecked />
        ) : <RbCircledUnchecked />}

        <Text ml={2}>{props.children}</Text>
      </Flex>
    </components.Option>
  );
};

const SelectedResourceItem = ({ text, onRemove }: { text: string, onRemove: () => void }) => {
  return (
    <Flex mt={2}>
      <Flex alignItems={'center'} padding={'4px'} flex={1} style={{ borderRadius: '8px 0 0 8px', border: '1px solid #344F7A' }}>
        <Text fontWeight={300} fontSize='14px' ml={1}>{text}</Text>
      </Flex>
      <Flex alignItems={'center'} padding={'4px 8px'} onClick={onRemove} style={{ cursor: 'pointer', borderRadius: '0 8px 8px 0', border: '1px solid #344F7A', borderLeftWidth: 0, background: '#ebebeb' }}>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M15.59 7L12 10.59L8.41 7L7 8.41L10.59 12L7 15.59L8.41 17L12 13.41L15.59 17L17 15.59L13.41 12L17 8.41L15.59 7Z" fill="#344F7A" />
        </svg>

      </Flex>
    </Flex>
  )
}

const RightColumnContainer = styled(Flex)`
  border: 1px solid #d6dde3; 
  background: white; 
  border-radius: 0 10px 10px 0; 
  border-left-width: 0;
  overflow-y: auto;
  @media screen and (max-width: 68.8125em) {
    border: 0px solid #d6dde3;
    background: transparent;
  }
`

const Wrapper = styled(Flex)`
  overflow: auto;
  flex-direction: column;
  padding-right: 16px;
  padding-left: 16px;
  overflow-x: hidden;
  flex: 1;
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: #6c89b7;
    border-radius: 5px;
  }
  &::-webkit-scrollbar {
    width: 7px;
    border: 1px solid transparent;
  }
`;
const HoverableCard = styled(Card)`
  transition:all 0.3s ease;
  flex: initial;
  background: white;
  margin-bottom: 8px;
  cursor: pointer;
`

const Preview: React.FC<{ mailboxId: string, id: string, name: string, onBack: () => void, okPressed: (text: string) => void, onCancel: () => void }> = ({ mailboxId, id, name, onBack, okPressed, onCancel }) => {
  const { data: dataSavedReplies, loading: loadingSavedReplies } = useQuery<IGetHSSavedReplyOutput, IGetHSSavedReplyInput>(GET_HS_SAVED_REPLY, {
    variables: {
      mailboxId: mailboxId.toString(),
      savedReplyId: id
    }
  })

  if (!!loadingSavedReplies) {
    return (
      <>
        <Flex alignItems={'center'} mb={3} flexDirection={['column', 'row', 'row']}>
          <svg onClick={onBack} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.25 11.25H20.25C20.4489 11.25 20.6397 11.329 20.7803 11.4697C20.921 11.6103 21 11.8011 21 12C21 12.1989 20.921 12.3897 20.7803 12.5303C20.6397 12.671 20.4489 12.75 20.25 12.75H5.25C5.05109 12.75 4.86032 12.671 4.71967 12.5303C4.57902 12.3897 4.5 12.1989 4.5 12C4.5 11.8011 4.57902 11.6103 4.71967 11.4697C4.86032 11.329 5.05109 11.25 5.25 11.25Z" fill="black" />
            <path d="M5.56086 12L11.7814 18.219C11.9222 18.3598 12.0013 18.5508 12.0013 18.75C12.0013 18.9491 11.9222 19.1401 11.7814 19.281C11.6405 19.4218 11.4495 19.5009 11.2504 19.5009C11.0512 19.5009 10.8602 19.4218 10.7194 19.281L3.96936 12.531C3.89952 12.4613 3.84411 12.3785 3.8063 12.2874C3.76849 12.1963 3.74902 12.0986 3.74902 12C3.74902 11.9013 3.76849 11.8036 3.8063 11.7125C3.84411 11.6214 3.89952 11.5386 3.96936 11.469L10.7194 4.71897C10.8602 4.57814 11.0512 4.49902 11.2504 4.49902C11.4495 4.49902 11.6405 4.57814 11.7814 4.71897C11.9222 4.8598 12.0013 5.05081 12.0013 5.24997C12.0013 5.44913 11.9222 5.64014 11.7814 5.78097L5.56086 12Z" fill="black" />
          </svg>

          <Text mr={[0, 4, 4]} mb={[2, 0, 0]} fontSize='18px' fontWeight={500}>{name}</Text>

        </Flex>
        <Text>Loading...</Text>
      </>
    )
  }

  if (!dataSavedReplies || !dataSavedReplies.getHSSavedReply) {
    return (
      <>
        <Flex alignItems={'center'} mb={3} flexDirection={['column', 'row', 'row']}>
          <svg onClick={onBack} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.25 11.25H20.25C20.4489 11.25 20.6397 11.329 20.7803 11.4697C20.921 11.6103 21 11.8011 21 12C21 12.1989 20.921 12.3897 20.7803 12.5303C20.6397 12.671 20.4489 12.75 20.25 12.75H5.25C5.05109 12.75 4.86032 12.671 4.71967 12.5303C4.57902 12.3897 4.5 12.1989 4.5 12C4.5 11.8011 4.57902 11.6103 4.71967 11.4697C4.86032 11.329 5.05109 11.25 5.25 11.25Z" fill="black" />
            <path d="M5.56086 12L11.7814 18.219C11.9222 18.3598 12.0013 18.5508 12.0013 18.75C12.0013 18.9491 11.9222 19.1401 11.7814 19.281C11.6405 19.4218 11.4495 19.5009 11.2504 19.5009C11.0512 19.5009 10.8602 19.4218 10.7194 19.281L3.96936 12.531C3.89952 12.4613 3.84411 12.3785 3.8063 12.2874C3.76849 12.1963 3.74902 12.0986 3.74902 12C3.74902 11.9013 3.76849 11.8036 3.8063 11.7125C3.84411 11.6214 3.89952 11.5386 3.96936 11.469L10.7194 4.71897C10.8602 4.57814 11.0512 4.49902 11.2504 4.49902C11.4495 4.49902 11.6405 4.57814 11.7814 4.71897C11.9222 4.8598 12.0013 5.05081 12.0013 5.24997C12.0013 5.44913 11.9222 5.64014 11.7814 5.78097L5.56086 12Z" fill="black" />
          </svg>
          <Text mr={[0, 4, 4]} mb={[2, 0, 0]} fontSize='18px' fontWeight={500}>{name}</Text>

        </Flex>
        <Text>Not found</Text>
      </>
    )
  }
  return (
    <>
      <Flex alignItems={'center'} mb={3} flexDirection={['column', 'row', 'row']}>
        <svg onClick={onBack} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M5.25 11.25H20.25C20.4489 11.25 20.6397 11.329 20.7803 11.4697C20.921 11.6103 21 11.8011 21 12C21 12.1989 20.921 12.3897 20.7803 12.5303C20.6397 12.671 20.4489 12.75 20.25 12.75H5.25C5.05109 12.75 4.86032 12.671 4.71967 12.5303C4.57902 12.3897 4.5 12.1989 4.5 12C4.5 11.8011 4.57902 11.6103 4.71967 11.4697C4.86032 11.329 5.05109 11.25 5.25 11.25Z" fill="black" />
          <path d="M5.56086 12L11.7814 18.219C11.9222 18.3598 12.0013 18.5508 12.0013 18.75C12.0013 18.9491 11.9222 19.1401 11.7814 19.281C11.6405 19.4218 11.4495 19.5009 11.2504 19.5009C11.0512 19.5009 10.8602 19.4218 10.7194 19.281L3.96936 12.531C3.89952 12.4613 3.84411 12.3785 3.8063 12.2874C3.76849 12.1963 3.74902 12.0986 3.74902 12C3.74902 11.9013 3.76849 11.8036 3.8063 11.7125C3.84411 11.6214 3.89952 11.5386 3.96936 11.469L10.7194 4.71897C10.8602 4.57814 11.0512 4.49902 11.2504 4.49902C11.4495 4.49902 11.6405 4.57814 11.7814 4.71897C11.9222 4.8598 12.0013 5.05081 12.0013 5.24997C12.0013 5.44913 11.9222 5.64014 11.7814 5.78097L5.56086 12Z" fill="black" />
        </svg>
        <Text mr={[0, 4, 4]} mb={[2, 0, 0]} fontSize='18px' fontWeight={500}>{name}</Text>

      </Flex>
      {(dataSavedReplies!.getHSSavedReply!.text || '').indexOf('<img') > -1 ? (
        <Flex backgroundColor={'red'} mb={3} paddingX={'16px'} paddingY={'8px'}>
          <Text color={'white'}>Health Coach App is unable to handle Saved Replies with images </Text>
        </Flex>
      ) : null}
      <Wrapper flexDirection={'column'} >
        <Box flex={1} backgroundColor={'white'} padding={'24px'}>
          <Text dangerouslySetInnerHTML={{ __html: dataSavedReplies.getHSSavedReply.text }}></Text>
        </Box>
      </Wrapper>
      <Flex justifyContent={'flex-end'} mt={4} >
        <Button variant={'outline'} onClick={onCancel} style={{ width: 'auto' }}>Cancel</Button>

        <Button variant={'primary'} ml={4} onClick={() => okPressed(dataSavedReplies!.getHSSavedReply!.text)} disabled={(dataSavedReplies!.getHSSavedReply!.text || '').indexOf('<img') > -1}>Insert</Button>
      </Flex>
    </>
  )
}

const PreviewWithAthenaId: React.FC<{
  athenaId: string, mailboxId: string, id: string, name: string, onBack: () => void, okPressed: (text: string) => void, onCancel: () => void,
  session: IUser
}> = ({ mailboxId, id, name, onBack, okPressed, onCancel, athenaId, session }) => {
  console.log('withAthena')
  const { data: dataSavedReplies, loading: loadingSavedReplies } = useQuery<IGetHSSavedReplyOutput, IGetHSSavedReplyInput>(GET_HS_SAVED_REPLY, {
    variables: {
      mailboxId: mailboxId.toString(),
      savedReplyId: id
    }
  })
  const { data: dataPatient, loading: loadingPatient, error: errorPatient } = useQuery<IGetProviderPatientByIdOutput, IGetProviderPatientByIdInput>(GET_PATIENT_BY_ID, {
    variables: {
      id: athenaId
    }
  })

  const replacePlaceHolders = (text: string) => {
    if (!dataPatient || !dataPatient.getProviderPatientById) return text
    return text.replace(/\{%customer\.firstName\,fallback=%\}/g, dataPatient.getProviderPatientById.firstname || '{%customer.firstName,fallback=%}')
      .replace(/\{%user\.firstName%\}/g, (session.displayName) || '{%user.firstName}')
  }

  if (!!loadingSavedReplies || loadingPatient) {
    return (
      <>
        <Flex alignItems={'center'} mb={3} flexDirection={['column', 'row', 'row']}>
          <svg onClick={onBack} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.25 11.25H20.25C20.4489 11.25 20.6397 11.329 20.7803 11.4697C20.921 11.6103 21 11.8011 21 12C21 12.1989 20.921 12.3897 20.7803 12.5303C20.6397 12.671 20.4489 12.75 20.25 12.75H5.25C5.05109 12.75 4.86032 12.671 4.71967 12.5303C4.57902 12.3897 4.5 12.1989 4.5 12C4.5 11.8011 4.57902 11.6103 4.71967 11.4697C4.86032 11.329 5.05109 11.25 5.25 11.25Z" fill="black" />
            <path d="M5.56086 12L11.7814 18.219C11.9222 18.3598 12.0013 18.5508 12.0013 18.75C12.0013 18.9491 11.9222 19.1401 11.7814 19.281C11.6405 19.4218 11.4495 19.5009 11.2504 19.5009C11.0512 19.5009 10.8602 19.4218 10.7194 19.281L3.96936 12.531C3.89952 12.4613 3.84411 12.3785 3.8063 12.2874C3.76849 12.1963 3.74902 12.0986 3.74902 12C3.74902 11.9013 3.76849 11.8036 3.8063 11.7125C3.84411 11.6214 3.89952 11.5386 3.96936 11.469L10.7194 4.71897C10.8602 4.57814 11.0512 4.49902 11.2504 4.49902C11.4495 4.49902 11.6405 4.57814 11.7814 4.71897C11.9222 4.8598 12.0013 5.05081 12.0013 5.24997C12.0013 5.44913 11.9222 5.64014 11.7814 5.78097L5.56086 12Z" fill="black" />
          </svg>

          <Text mr={[0, 4, 4]} mb={[2, 0, 0]} fontSize='18px' fontWeight={500}>{name}</Text>

        </Flex>
        <Text>Loading...</Text>
      </>
    )
  }

  if (!dataSavedReplies || !dataSavedReplies.getHSSavedReply) {
    return (
      <>
        <Flex alignItems={'center'} mb={3} flexDirection={['column', 'row', 'row']}>
          <svg onClick={onBack} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.25 11.25H20.25C20.4489 11.25 20.6397 11.329 20.7803 11.4697C20.921 11.6103 21 11.8011 21 12C21 12.1989 20.921 12.3897 20.7803 12.5303C20.6397 12.671 20.4489 12.75 20.25 12.75H5.25C5.05109 12.75 4.86032 12.671 4.71967 12.5303C4.57902 12.3897 4.5 12.1989 4.5 12C4.5 11.8011 4.57902 11.6103 4.71967 11.4697C4.86032 11.329 5.05109 11.25 5.25 11.25Z" fill="black" />
            <path d="M5.56086 12L11.7814 18.219C11.9222 18.3598 12.0013 18.5508 12.0013 18.75C12.0013 18.9491 11.9222 19.1401 11.7814 19.281C11.6405 19.4218 11.4495 19.5009 11.2504 19.5009C11.0512 19.5009 10.8602 19.4218 10.7194 19.281L3.96936 12.531C3.89952 12.4613 3.84411 12.3785 3.8063 12.2874C3.76849 12.1963 3.74902 12.0986 3.74902 12C3.74902 11.9013 3.76849 11.8036 3.8063 11.7125C3.84411 11.6214 3.89952 11.5386 3.96936 11.469L10.7194 4.71897C10.8602 4.57814 11.0512 4.49902 11.2504 4.49902C11.4495 4.49902 11.6405 4.57814 11.7814 4.71897C11.9222 4.8598 12.0013 5.05081 12.0013 5.24997C12.0013 5.44913 11.9222 5.64014 11.7814 5.78097L5.56086 12Z" fill="black" />
          </svg>
          <Text mr={[0, 4, 4]} mb={[2, 0, 0]} fontSize='18px' fontWeight={500}>{name}</Text>

        </Flex>
        <Text>Not found</Text>
      </>
    )
  }
  return (
    <>
      <Flex alignItems={'center'} mb={3} flexDirection={['column', 'row', 'row']}>
        <svg onClick={onBack} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M5.25 11.25H20.25C20.4489 11.25 20.6397 11.329 20.7803 11.4697C20.921 11.6103 21 11.8011 21 12C21 12.1989 20.921 12.3897 20.7803 12.5303C20.6397 12.671 20.4489 12.75 20.25 12.75H5.25C5.05109 12.75 4.86032 12.671 4.71967 12.5303C4.57902 12.3897 4.5 12.1989 4.5 12C4.5 11.8011 4.57902 11.6103 4.71967 11.4697C4.86032 11.329 5.05109 11.25 5.25 11.25Z" fill="black" />
          <path d="M5.56086 12L11.7814 18.219C11.9222 18.3598 12.0013 18.5508 12.0013 18.75C12.0013 18.9491 11.9222 19.1401 11.7814 19.281C11.6405 19.4218 11.4495 19.5009 11.2504 19.5009C11.0512 19.5009 10.8602 19.4218 10.7194 19.281L3.96936 12.531C3.89952 12.4613 3.84411 12.3785 3.8063 12.2874C3.76849 12.1963 3.74902 12.0986 3.74902 12C3.74902 11.9013 3.76849 11.8036 3.8063 11.7125C3.84411 11.6214 3.89952 11.5386 3.96936 11.469L10.7194 4.71897C10.8602 4.57814 11.0512 4.49902 11.2504 4.49902C11.4495 4.49902 11.6405 4.57814 11.7814 4.71897C11.9222 4.8598 12.0013 5.05081 12.0013 5.24997C12.0013 5.44913 11.9222 5.64014 11.7814 5.78097L5.56086 12Z" fill="black" />
        </svg>
        <Text mr={[0, 4, 4]} mb={[2, 0, 0]} fontSize='18px' fontWeight={500}>{name}</Text>

      </Flex>
      {(dataSavedReplies!.getHSSavedReply!.text || '').indexOf('<img') > -1 ? (
        <Flex backgroundColor={'red'} mb={3} paddingX={'16px'} paddingY={'8px'}>
          <Text color={'white'}>Health Coach App is unable to handle Saved Replies with images </Text>
        </Flex>
      ) : null}
      <Wrapper flexDirection={'column'} >
        <Box flex={1} backgroundColor={'white'} padding={'24px'}>
          <Text dangerouslySetInnerHTML={{ __html: replacePlaceHolders(dataSavedReplies.getHSSavedReply.text) }}></Text>
        </Box>
      </Wrapper>
      <Flex justifyContent={'flex-end'} mt={4} >
        <Button variant={'outline'} onClick={onCancel} style={{ width: 'auto' }}>Cancel</Button>

        <Button variant={'primary'} ml={4} onClick={() => okPressed(replacePlaceHolders(dataSavedReplies!.getHSSavedReply!.text))} disabled={(dataSavedReplies!.getHSSavedReply!.text || '').indexOf('<img') > -1}>Insert</Button>
      </Flex>
    </>
  )
}
const SavedRepliesModal = ({ okPressed, onCancel, mailboxId, athenaId, session }: { okPressed: (text: string) => void, onCancel: () => void, mailboxId: number, athenaId?: string | null, session: IUser }) => {
  const [selectedReply, setSelectedReply] = useState<{ id: string, name: string } | null>()
  const [filter, setFilter] = useState<string | null>()
  const { data: dataSavedReplies, loading: loadingSavedReplies } = useQuery<IGetHSSavedRepliesOutput, IGetHSSavedRepliesInput>(GET_HS_SAVED_REPLIES, {
    variables: {
      mailboxId: mailboxId.toString()
    }
  })
  console.log('withAthena', athenaId)
  return (
    <Wrap
      flexDirection={'column'}
      paddingX={[0, 4, 4]}
      paddingY={4}
      height={['calc(100% - 70px)', '80%', '80%']}
      maxHeight={['calc(100% - 70px)', '80%', '80%']}
      alignSelf={['flex-start', 'auto', 'auto']}
      style={{
        background: '#f1f3f5',
        width: '80%',
        zIndex: 1001, overflow: 'hidden'
      }}>
      <Flex alignItems={'center'} mb={3} flexDirection={['column', 'row', 'row']}>
        <Text mr={[0, 4, 4]} mb={[2, 0, 0]} fontSize='18px' fontWeight={500}>Saved Replies</Text>
        <Input value={filter}
          autoFocus
          placeholder='Search'
          onChange={(e: any) => {
            setFilter(e.target.value);
          }} />
      </Flex>
      <Box style={{ width: '100%', height: '1px', backgroundColor: '#d5dce1' }} />
      {!selectedReply ? (
        <>
          {!loadingSavedReplies && dataSavedReplies && dataSavedReplies.getHSSavedReplies && (
            <Wrapper flexDirection={'column'} >
              <Flex flexDirection={'column'}>
                {!filter ? (
                  <>
                    {dataSavedReplies.getHSSavedReplies.map(x => {
                      return (
                        <HoverableCard key={x.id} paddingX={'16px'} paddingY={'8px'} style={{ border: '1px solid ' }} onClick={() => setSelectedReply({
                          id: x.id,
                          name: x.name
                        })}>
                          <Text >{x.name}</Text>
                        </HoverableCard>
                      )
                    })}
                  </>
                ) : (
                  <>
                    {dataSavedReplies.getHSSavedReplies.filter(x => x.name.toLowerCase().indexOf(filter.toLowerCase()) > -1).map(x => {
                      return (
                        <HoverableCard key={x.id} paddingX={'16px'} paddingY={'8px'} style={{ border: '1px solid ' }} onClick={() => setSelectedReply({
                          id: x.id,
                          name: x.name
                        })}>
                          <Text >{x.name}</Text>
                        </HoverableCard>
                      )
                    })}
                  </>
                )}
              </Flex>
            </Wrapper>
          )}

          <Flex justifyContent={'flex-end'} mt={3}>
            <Button variant={'outline'} onClick={onCancel} width='auto'>Cancel</Button>
          </Flex>
        </>
      ) : (
        <>
          {!athenaId ? (

            <Preview name={selectedReply.name} id={selectedReply.id} mailboxId={mailboxId.toString()} onBack={() => setSelectedReply(null)}
              onCancel={onCancel} okPressed={okPressed} />
          ) : (
            <PreviewWithAthenaId session={session} athenaId={athenaId} name={selectedReply.name} id={selectedReply.id} mailboxId={mailboxId.toString()} onBack={() => setSelectedReply(null)}
              onCancel={onCancel} okPressed={okPressed} />)}
        </>
      )}
    </Wrap>
  )
}

export default withSession(SavedRepliesModal)